import React, { Component } from "react";
import axios from "axios";
import { FaDownload } from "react-icons/fa";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import Select from "react-select";
import { getcyclelist } from "store/cycle/actions";
import { getbanklist } from "store/banks/actions";
import { updatePayment } from "store/Payment/actions";
// import { Button } from "react-bootstrap";
import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Row,
  Label,
  Modal,
  Input,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button, // ✅ Add this here
} from "reactstrap";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import filterFactory from "react-bootstrap-table2-filter";
import Breadcrumbs from "components/Common/Breadcrumb";
import { getParticipantPayment, confirmpayment } from "store/Payment/actions";
import "assets/scss/table.scss";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { add } from "lodash";

class ParticipantPayments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nameFilter: "",
      idFilter: "",
      districtFilter: "",
      schemeFilter: "",
      schemeModalOpen: false,
      showReconcileModal: false,
      amountFilter: "",
      discountFilter: "",
      schemepriceFilter: "",
      pendingReconcileStatus: null,
      hoveredSchemeNames: [],
      CycleList: [],
      showReconcileDetailsModal: false,
      reconcileDate: "", // Date of reconcile
      activeRowId: null,
      paymentConfirmState: {},
      TaxFilter: "",
      dateFilter: "",
      filtersApplied: false,
      hoveredSchemeNames: [],
      paymentmodeFilter: "",
      dateFilter: "",
      paymentreceivedFilter: "",
      ListBank: [], // From Redux
      selectedBankAccount: null,
      selectedBankName: "",
      selectedCheckboxes: {},
      tableKey: 0,
      dateTo: new Date().toISOString().split("T")[0], // Show current date
      dateToActive: false, // Tracks whether the user activated the filter
      filtersApplied: false, // Prevent data from loading by default
      GetPayment: [],
      feedbackMessage: "",
      errorMessage: "",
      paymentsettlementFilter: "",
      paymentMethodFilter: "",
      paymentStatusFilter: "",
      reconcileStatusFilter: "",
      finalpayableFilter: "",
      paidamountFilter: "",
      remainingAmountFilter: "",
      membershipStatusFilter: "",
      payment_received_date: "",
      dateFrom: "",
      // dateTo: "",
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      feedbackListColumns: [
        {
          text: "Payment ID",
          dataField: "id",
          sort: true,
          hidden: false,
          headerStyle: {
            backgroundColor: "#87ceeb", // 🌤 sky blue for header
            textAlign: "center",
          },
          style: {
            // backgroundColor: "#87ceeb", // 🌤 sky blue for cells
            textAlign: "center",
          },
          formatter: (cellContent, methodlist) => <>P-{methodlist.id}</>,
          headerFormatter: (column, colIndex) => (
            <>
              <div style={{ textAlign: "center", marginBottom: "5px" }}>
                {column.text}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                }}
              >
                <input
                  type="text"
                  value={this.state.idFilter}
                  onChange={(e) => this.handleFilterChange("idFilter", e)}
                  className="form-control"
                />
              </div>
            </>
          ),
        },
        {
          dataField: "participant_name",
          text: "Participant Name",
          sort: true,
          headerStyle: {
            backgroundColor: "#87ceeb",
            textAlign: "left",
          },
          style: {
            textAlign: "left",
          },
          formatter: (cell, row) => (
            <span
              style={{ color: "#0d6efd", cursor: "pointer" }}
              onClick={() => this.openParticipantModal(row)}
            >
              {cell}
            </span>
          ),
          headerFormatter: (column) => (
            <div style={{ textAlign: "left" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  placeholder={column.text} // ✅ same as “Participant Name”
                  value={this.state.nameFilter}
                  onChange={(e) => this.handleFilterChange("nameFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "left",
                    width: "120px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },

        // {
        //   dataField: "membership_status",
        //   text: "Participant Status",
        //   sort: true,
        //   headerStyle: {
        //     backgroundColor: "#87ceeb", // 🌤 sky blue for header
        //     textAlign: "center",
        //   },
        //   style: {
        //     textAlign: "right",
        //   },
        //   headerFormatter: (column, colIndex) => (
        //     <div style={{ textAlign: "center" }}>
        //       <div>{column.text}</div>
        //       <div style={{ marginTop: "5px" }}>
        //         <input
        //           type="text"
        //           value={this.state.membershipStatusFilter || ""}
        //           onChange={e =>
        //             this.handleFilterChange("membershipStatusFilter", e)
        //           }
        //           className="form-control"
        //           style={{
        //             textAlign: "center",
        //             width: "100px",
        //             margin: "auto",
        //           }}
        //         />
        //       </div>
        //     </div>
        //   ),
        // },
        {
          dataField: "district",
          text: "District",
          sort: true,
          headerStyle: {
            backgroundColor: "#87ceeb", // 🌤 sky blue for header
            textAlign: "center",
          },
          style: {
            textAlign: "center",
          },
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.districtFilter}
                  onChange={(e) => this.handleFilterChange("districtFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "70px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        // {
        //   dataField: "scheme_count",
        //   text: "Scheme",
        //   sort: true,
        //   headerStyle: {
        //     backgroundColor: "#87ceeb", // 🌤 sky blue for header
        //     textAlign: "center",
        //   },
        //   style: {
        //     textAlign: "right",
        //   },
        //   headerFormatter: (column, colIndex) => (
        //     <div style={{ textAlign: "center" }}>
        //       <div>{column.text}</div>
        //       <div style={{ marginTop: "5px" }}>
        //         <input
        //           type="text"
        //           value={this.state.schemeFilter}
        //           onChange={e => this.handleFilterChange("schemeFilter", e)}
        //           className="form-control"
        //           style={{
        //             textAlign: "center",
        //             width: "100px",
        //             margin: "auto",
        //           }}
        //         />
        //       </div>
        //     </div>
        //   ),
        //   formatter: (cell, row) => (
        //     <div
        //       onClick={() => this.handleSchemeClick(row)} // <- Changed to onClick
        //       style={{
        //         cursor: "pointer",
        //         textAlign: "center",
        //         color: "blue",
        //       }}
        //     >
        //       {cell}
        //     </div>
        //   ),
        // },
        {
          dataField: "priceBeforeDiscount",
          text: "Payable",
          sort: true,
          headerStyle: {
            backgroundColor: "#fff9c4",
            textAlign: "center",
          },
          style: {
            backgroundColor: "#fff9c4",
            textAlign: "right",
          },
          formatter: (cell) => this.formatNumber(cell),
          headerFormatter: (column, colIndex) => (
            <div>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.schemepriceFilter}
                  onChange={(e) =>
                    this.handleFilterChange("schemepriceFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "70px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "discountAmount",
          text: "Discount Amount",
          sort: true,
          headerStyle: {
            backgroundColor: "#fff9c4",
            textAlign: "center",
          },
          style: {
            backgroundColor: "#fff9c4",
            textAlign: "right",
          },
          formatter: (cell) => this.formatNumber(cell),

          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.discountFilter}
                  onChange={(e) => this.handleFilterChange("discountFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "70px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "taxDeduction",
          text: "Tax",
          sort: true,
          headerStyle: {
            backgroundColor: "#fff9c4",
            textAlign: "center",
          },
          style: {
            backgroundColor: "#fff9c4",
            textAlign: "right",
          },
          formatter: (cell) => {
            const value = Number(cell);
            return value === 0 || isNaN(value) ? "-" : value.toLocaleString();
          },
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.TaxFilter}
                  onChange={(e) => this.handleFilterChange("TaxFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "70px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "price",
          text: "Final Payable",
          sort: true,
          headerStyle: {
            backgroundColor: "#fff9c4",
            textAlign: "center",
          },
          style: {
            backgroundColor: "#fff9c4",
            textAlign: "right",
          },
          formatter: (cell, row) => {
            const price = parseFloat(row.price) || 0;
            const discount = parseFloat(row.discount) || 0;
            const tax = parseFloat(row.tax) || 0;

            const payable = price - discount - tax;
            return this.formatNumber(payable);
          },

          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.finalpayableFilter}
                  onChange={(e) =>
                    this.handleFilterChange("finalpayableFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "70px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "payment_settlement",
          text: "Payment Settlement",
          sort: true,
          headerStyle: {
            backgroundColor: "#d0e2ff", // 🔵 light blue for header
            textAlign: "center",
          },
          style: {
            backgroundColor: "#d0e2ff", // 🔵 light blue for cells
            textAlign: "right",
          },
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.paymentsettlementFilter}
                  onChange={(e) =>
                    this.handleFilterChange("paymentsettlementFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "70px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "payment_status",
          text: "Payment Status",
          sort: true,
          headerStyle: {
            backgroundColor: "#d0e2ff", // light blue header
            textAlign: "center",
          },
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.paymentStatusFilter}
                  onChange={(e) =>
                    this.handleFilterChange("paymentStatusFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "70px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
          formatter: (cell, row) => {
            const priceBeforeDiscount = Number(row.priceBeforeDiscount) || 0;
            const discountAmount = Number(row.discountAmount) || 0;
            const finalPayable = Number(row.price) || 0;

            // ✅ 100% discount conditions
            const isFullDiscount =
              discountAmount === priceBeforeDiscount || finalPayable === 0;

            // ✅ Decide color
            const color =
              row.payment_reconcile_status === "Verified" || isFullDiscount
                ? "green"
                : "red";

            return (
              <span style={{ color, fontWeight: "bold" }}>{cell || "-"}</span>
            );
          },

          style: { textAlign: "right" }, // remove fixed background
        },

        // {
        //   dataField: "payment_reconcile_status",
        //   text: "Verification Status",
        //   formatter: (cell, row) => {
        //     const status = row.payment_reconcile_status;

        //     if (status === "Verified") {
        //       return (
        //         <a
        //           href="#"
        //           onClick={e => {
        //             e.preventDefault();
        //             this.handleViewReconcileDetails(row); // ✅ Use row directly
        //           }}
        //         >
        //           {status}
        //         </a>
        //       );
        //     }

        //     return (
        //       <span style={{ color: "gray", cursor: "not-allowed" }}>
        //         {status || "-"}
        //       </span>
        //     );
        //   },
        // },
        {
          dataField: "part_payment_amount",
          text: "Paid Amount",
          sort: true,
          headerStyle: {
            backgroundColor: "#d0e2ff",
            textAlign: "center",
          },
          style: {
            backgroundColor: "#d0e2ff",
            textAlign: "right",
          },

          formatter: (cell, row) => {
            // ✅ Full payment case
            if (row.payment_settlement === "Full") {
              return this.formatNumber(row.price);
            }

            // ✅ Part payment case
            return this.formatNumber(cell);
          },

          headerFormatter: (column) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.paidamountFilter}
                  onChange={(e) =>
                    this.handleFilterChange("paidamountFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "70px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "remaining_amount",
          text: "Remaining Amount",
          sort: true,
          headerStyle: {
            backgroundColor: "#87ceeb", // 🌤 sky blue for header
            textAlign: "center",
          },
          style: {
            textAlign: "right",
          },
          formatter: (cell) => this.formatNumber(cell),
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.remainingAmountFilter}
                  onChange={(e) =>
                    this.handleFilterChange("remainingAmountFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "70px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "payment_info",
          text: "Payment Mode & Date",
          sort: true,
          headerStyle: {
            backgroundColor: "#87ceeb",
            textAlign: "center",
          },
          style: {
            textAlign: "center",
          },
          formatter: (cell, row) => {
            const receiptUrl = row.photo_url || null;
            const paymentMethod = row.paymentmethod || "-";

            // Decide date
            const dateToShow =
              row.payment_status === "Payment In process"
                ? row.created_at
                : row.paydate;

            let formattedDate = "-";
            if (dateToShow) {
              const d = new Date(dateToShow);
              if (!isNaN(d)) {
                const day = String(d.getDate()).padStart(2, "0");
                const month = d.toLocaleString("en-US", { month: "short" });
                const year = String(d.getFullYear()).slice(-2);
                formattedDate = `${day}-${month}-${year}`;
              }
            }

            return (
              <div className="d-flex flex-column align-items-center">
                {receiptUrl ? (
                  <a
                    href={receiptUrl}
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-flex align-items-center text-decoration-none text-primary"
                    title="Payment Mode" // ✅ hover on slip/mode
                  >
                    <span className="me-1">{paymentMethod}</span>
                    <FaDownload />
                  </a>
                ) : (
                  <span title="Payment Mode">{paymentMethod}</span>
                )}

                {/* 🔹 Payment Date (hover → Payment Date) */}
                <div className="text-muted" title="Payment Date">
                  {formattedDate}
                </div>
              </div>
            );
          },
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>
                <div>Payment Mode & Date</div>
              </div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.paymentInfoFilter}
                  onChange={(e) =>
                    this.handleFilterChange("paymentInfoFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "70px",
                    margin: "auto",
                  }}
                  placeholder="Filter"
                />
              </div>
            </div>
          ),
        },

        {
          dataField: "receivedby",
          text: "Payment Received by",
          sort: true,
          headerStyle: {
            backgroundColor: "#87ceeb", // 🌤 sky blue for header
            textAlign: "center",
          },
          style: {
            textAlign: "right",
          },
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.paymentreceivedFilter}
                  onChange={(e) =>
                    this.handleFilterChange("paymentreceivedFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "60px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "action_item",
          text: "Action",
          headerStyle: {
            textAlign: "center",
            verticalAlign: "middle",
          },
          formatter: (cell, row) => {
            const { paymentConfirmState } = this.state;
            const rowState = paymentConfirmState?.[row.id] || {};
            const status =
              row.payment_reconcile_status || rowState.reconcileStatus || "";

            return (
              <div
                className="d-flex flex-row align-items-center gap-2"
                onClick={(e) => e.stopPropagation()} // ⛔ prevent parent row click
              >
                {row.payment_status &&
                  row.payment_status
                    .toString()
                    .toLowerCase()
                    .includes("process") && (
                    <Tooltip title="Edit Payment">
                      <i
                        className="mdi mdi-pencil-outline"
                        style={{
                          cursor: "pointer",
                          fontSize: "20px",
                          color: "#28a745",
                        }}
                        onClick={() => this.toggleEditModal(row)}
                      />
                    </Tooltip>
                  )}

                {/* Payment details link */}
                <Tooltip title="Payment Details">
                  <Link
                    to={`/PaymentCSR-scheme-list/${row.participant_id}?payment_id=${row.id}`}
                    onClick={() => {
                      console.log(
                        "Navigating to participant ID:",
                        row.user_id || row.participant_id,
                      );
                      this.saveFiltersToSession();
                    }}
                    style={{ textDecoration: "underline", color: "#0000CD" }}
                  >
                    <i className="mdi mdi-credit-card-outline font-size-18" />
                  </Link>
                </Tooltip>

                <Tooltip title="Set Verification Status">
                  <i
                    className="mdi mdi-checkbox-marked-circle-outline"
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "#0000CD", // Dark blue
                    }}
                    onClick={() => this.handleOpenModal(row.id)}
                  />
                </Tooltip>
                <Tooltip title="History">
                  <Link
                    className="fas fa-comment font-size-18"
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      const url = `/${this.state.organization_name}/Participant-History/${row.participant_id}`;
                      this.props.history.push(url);
                    }}
                  ></Link>
                </Tooltip>
              </div>
            );
          },
        },
      ],
      tableKey: Date.now(), // ✅ so you can force re-render
    };
  }
  formatNumber = (value, options = {}) => {
    const num = Number(value);
    return !num || num === 0
      ? "-"
      : num.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
          ...options,
        });
  };

  handleCheckboxToggle = (rowId) => {
    this.setState((prevState) => ({
      paymentConfirmState: {
        ...prevState.paymentConfirmState,
        [rowId]: {
          ...prevState.paymentConfirmState[rowId],
          checked: !prevState.paymentConfirmState[rowId]?.checked,
        },
      },
      tableKey: Date.now(), // trigger full re-render of table
    }));
  };

  handleFileChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue("photo", file);
  };
  handleSaveConfirmation = (rowId) => {
    if (!rowId) {
      console.error("❌ rowId is undefined");
      return;
    }

    this.props.confirmpayment(rowId);

    this.setState((prevState) => ({
      paymentConfirmState: {
        ...prevState.paymentConfirmState,
        [rowId]: {
          checked: false,
          confirmed: true,
        },
      },
      tableKey: Date.now(), // 🔁 this will trigger <BootstrapTable> to fully re-render
    }));
  };
  handleOpenModal = (rowId) => {
    const row = this.state.GetPayment.find((r) => r.id === rowId);
    if (!row) return;

    const isVerified = row.payment_reconcile_status === "Verified";

    this.setState({
      showReconcileModal: true,
      activeRowId: rowId,
      activeParticipantName: row.participant_name || "Unknown",

      // Payment info
      activeRowPaymentId: row.id,
      activeRowPayable: row.price || "-",
      activeRowPaidAmount:
        row.part_payment_amount || row.priceBeforeDiscount || "-",
      activeRowPaymentDate: row.paydate || null,
      activeRowPaymentStatus: row.payment_reconcile_status || "Non-Verified",
      activeRowPaymentMode: row.paymentmethod || "-",

      // STATUS
      selectedReconcileStatus: row.payment_reconcile_status || "Non-Verified",
      pendingReconcileStatus: row.payment_reconcile_status || null,

      // Schemes
      activeRowSchemes: row.schemes || [],

      // 🔥 PREFILL INTO PENDING FIELDS
      pendingSelectedAccountNumber: isVerified ? row.account_number || "" : "",
      pendingBankName: isVerified ? row.bank_name || "" : "",
      pendingPaymentReceivedDate: isVerified
        ? row.payment_received_date || ""
        : "",
      pendingComments: isVerified ? row.comments || "" : "",
      pendingUploadedImage: isVerified ? row.attachment_url || null : null,
    });
  };

  handleCloseModal = () => {
    this.setState({
      showReconcileModal: false,
      activeRowId: null,
      activeParticipantName: "",
      selectedReconcileStatus: null,
    });
  };
  handleReconcileSubmit = () => {
    const {
      pendingReconcileStatus,
      pendingSelectedAccountNumber,
      pendingBankName,
      pendingComments,
      pendingPaymentReceivedDate,
      pendingUploadedImage,
      activeRowId,
    } = this.state;

    if (!pendingReconcileStatus) {
      alert("Please select a verification status.");
      return;
    }

    // Build payload
    const payload = {
      id: activeRowId,
      status: pendingReconcileStatus,
      account_number: pendingSelectedAccountNumber || null,
      bank_name: pendingBankName || null,
      user_id: this.state.user_id,
      comments: pendingComments,
      payment_received_date: pendingPaymentReceivedDate,
    };
    if (pendingUploadedImage) payload.attachment = pendingUploadedImage;

    this.props.confirmpayment(payload);

    // Update saved data after submission
    this.setState({
      activeRowPaymentStatus: pendingReconcileStatus,
      activeRowPaymentReceivedDate: pendingPaymentReceivedDate,
      activeRowAccountNumber: pendingSelectedAccountNumber,
      activeRowBankName: pendingBankName,
      activeRowComments: pendingComments,
      activeRowAttachment: pendingUploadedImage,

      // Reset pending fields
      pendingReconcileStatus: null,
      pendingPaymentReceivedDate: "",
      pendingSelectedAccountNumber: "",
      pendingBankName: "",
      pendingComments: "",
      pendingUploadedImage: null,
    });

    this.handleCloseModal();
    setTimeout(() => this.props.onGetParticipantpayment(), 1000);
  };

  setReconcileStatus = (status) => {
    const rowId = this.state.activeRowId;

    // Dispatch saga
    this.props.confirmpayment({
      id: this.state.activeRowId, // Pass the active payment ID
      status: status, // Selected status
    });

    // Update UI locally
    this.setState((prevState) => {
      const updatedData = prevState.GetPayment.map((item) =>
        item.id === rowId
          ? { ...item, payment_reconcile_status: status }
          : item,
      );

      return {
        GetPayment: updatedData, // ✅ update row status
        paymentConfirmState: {
          ...prevState.paymentConfirmState,
          [rowId]: {
            ...prevState.paymentConfirmState[rowId],
            reconcileStatus: status,
          },
        },
        showReconcileModal: false,
        activeRowId: null,
      };
    });
  };
  handleOpenReconcileModal = (payment) => {
    this.setState({
      showReconcileModal: true,
      selectedPayment: payment,
      paymentReceived: payment.payment_received || "", // Prefill if data exists
      bankAccountNumber: payment.account_number || "", // Prefill if data exists
      reconcileDate:
        payment.reconcile_date || new Date().toISOString().split("T")[0], // Default to today
    });
  };
  handleCloseReconcileModal = () => {
    this.setState({
      showReconcileModal: false,
      selectedPayment: null,
      paymentReceived: "",
      bankAccountNumber: "",
      reconcileDate: "",
    });
  };

  handleSaveReconcile = () => {
    const {
      selectedPayment,
      paymentReceived,
      bankAccountNumber,
      reconcileDate,
    } = this.state;

    if (!paymentReceived || !bankAccountNumber || !reconcileDate) {
      alert("Please fill in all fields.");
      return;
    }

    const payload = {
      id: selectedPayment.id,
      payment_received: paymentReceived,
      account_number: bankAccountNumber,
      reconcile_date: reconcileDate,
      status: "Verified",
    };

    console.log("Verified Payload:", payload);

    this.props.confirmpayment(payload); // Dispatch the saga

    // Close the modal
    this.handleCloseReconcileModal();
  };

  componentDidMount() {
    this.loadFiltersFromSession();
    const {
      onGetParticipantpayment,
      onGetBankList,
      confirmpayment,
      ongetcyclelist,
    } = this.props;

    // Fetch user_id from localStorage
    const user_id = localStorage.getItem("authUser")
      ? JSON.parse(localStorage.getItem("authUser")).user_id
      : "";

    if (!user_id) {
      console.error("User ID is missing. Cannot fetch bank list.");
      return;
    }

    console.log("Component Mounted with User ID:", user_id);

    // Dispatch actions with the required user_id
    onGetParticipantpayment();
    onGetBankList(user_id); // Pass the user_id here
    confirmpayment();
    ongetcyclelist(user_id);
    window.addEventListener("beforeunload", this.saveFiltersToSession);
    // Add logging after API responses
    setTimeout(() => {
      console.log("Payments Fetched:", this.props.GetPayment); // Ensure account_number is included
      console.log("Banks Fetched:", this.props.ListBank); // Check bank list data
    }, 1000); // Allow sagas to fetch and update the state
  }

  handleViewReconcileDetails = (payment) => {
    if (payment.payment_reconcile_status !== "Verified") {
      console.log("Modal not shown for Non-Verified status.");
      return; // Do nothing if the status is not "Verified"
    }

    console.log("Opening Verified Details for Payment:", payment);
    this.setState({
      showReconcileDetailsModal: true,
      selectedPayment: payment,
    });
  };

  handleCloseReconcileDetailsModal = () => {
    this.setState({
      showReconcileDetailsModal: false,
      selectedPayment: null,
    });
  };
  fetchData(user_id) {
    const { onGetParticipantpayment, ongetcyclelist } = this.props;

    // Call participant payment API
    onGetParticipantpayment();
    console.log("onGetParticipantPayment called with user_id:", user_id);

    // Call cycle list API
    ongetcyclelist(user_id);
    console.log("ongetcyclelist called with user_id:", user_id);
  }
  handleSchemeChange = (event) => {
    const selectedScheme = event.target.value;
    console.log("Scheme selected:", selectedScheme);

    this.setState({ selectedScheme }, () => {
      this.applyFilters(); // Call filters after updating state
    });
  };
  componentDidUpdate(prevProps) {
    const { GetPayment, ListBank, CycleList } = this.props;
    // ✅ Update CycleList when it changes
    if (CycleList !== prevProps.CycleList) {
      console.log("Updated CycleList:", CycleList);
      this.setState({ CycleList });
    }
    // ✅ Handle payment updates
    if (
      GetPayment !== prevProps.GetPayment ||
      ListBank !== prevProps.ListBank
    ) {
      // Create a map of banks by account_number for quick lookup
      const bankMap = {};
      (ListBank || []).forEach((bank) => {
        bankMap[bank.account_number] = bank.name; // Map account_number to bank_name
      });

      const transformedData = (GetPayment || []).map((payment) => ({
        id: payment.id,
        participant_name: payment.participant_name,
        district: payment.district,
        scheme_count: payment.scheme_count,
        scheme_names: payment.scheme_names || [],
        schemes: payment.schemes || [],
        price: payment.price,
        priceBeforeDiscount: payment.priceBeforeDiscount,
        discountAmount: payment.discountAmount,
        taxDeduction: payment.taxDeduction,
        payment_settlement: payment.payment_settlement,
        paymentmethod: payment.paymentmethod,
        attachment_url: payment.attachment_url || payment.attachment, // ✅ include the URL
        payment_status: payment.payment_status,
        part_payment_amount: payment.part_payment_amount,
        remaining_amount: payment.remaining_amount,
        paydate: payment.paydate,
        photo_url: payment.photo_url,
        receivedby: payment.receivedby,
        membership_status: payment.membership_status,
        payment_reconcile_status: payment.payment_reconcile_status || "",
        reconcileStatus: payment.payment_reconcile_status || "",
        account_number: payment.account_number || null, // Include account_number
        bank_name: bankMap[payment.account_number] || "Unknown", // Lookup bank_name
        comments: payment.comments,
        payment_received_date: payment.payment_received_date,
        added_by_name: payment.added_by_name || "-", // new field
        reconciled_at: payment.reconciled_at || null,
        participant_id: payment.participant_id,
        cycle_no: payment.cycle_no || "-",
        remaining_round: payment.remaining_round || "-",
      }));

      const paymentConfirmState = {};
      transformedData.forEach((row) => {
        paymentConfirmState[row.id] = {
          reconcileStatus: row.reconcileStatus,
        };
      });

      this.setState({
        GetPayment: transformedData,
        paymentConfirmState,
      });
    }

    // ✅ Handle bank list updates
    if (ListBank !== prevProps.ListBank) {
      console.log("🏦 Banks received in props:", ListBank);
      this.setState({ ListBank });
    }
  }

  handleSchemeClick = (row) => {
    // If there's any timeout still running from previous hover, clear it
    if (this.mouseExitTimeout) {
      clearTimeout(this.mouseExitTimeout);
    }

    // Open the modal with row data
    this.setState({
      hoveredSchemeNames: row.scheme_names || [],
      schemeModalOpen: true,
      hoveredParticipantName: row.participant_name || "",
    });
  };
  toggleEditModal = (row, participant = null) => {
    // 🧼 Normalize scheme names for matching
    const matchedSchemes =
      row?.scheme_names
        ?.map((name) => {
          const cleanedName = name.replace(/,/g, "").trim().toLowerCase();
          const found = this.state.CycleList?.find((option) => {
            const optionName = option.scheme_name
              .replace(/,/g, "")
              .trim()
              .toLowerCase();
            return optionName === cleanedName;
          });
          return found;
        })
        .filter(Boolean) || [];

    // 🧠 Log actual price data for debug
    matchedSchemes.forEach((scheme, index) => {
      const raw = scheme?.priceBeforeDiscount || scheme?.price;
      const cleaned = parseFloat(raw?.toString().replace(/,/g, ""));
      console.log(`🔎 Scheme ${index + 1}`, {
        schemeName: scheme.scheme_name,
        rawPrice: raw,
        cleanedPrice: cleaned,
      });
    });

    // 💰 Corrected total price calculation
    const priceBeforeDiscount = matchedSchemes.reduce((sum, scheme) => {
      const raw = scheme?.priceBeforeDiscount || scheme?.price || 0;
      const cleaned = parseFloat(raw.toString().replace(/,/g, ""));
      return sum + (isNaN(cleaned) ? 0 : cleaned);
    }, 0);

    // 🪪 Format scheme IDs
    const scheme_ids = matchedSchemes.map(
      (opt) => `${opt.scheme_id}-${opt.id}`,
    );

    // 🧾 Debug final total
    console.log("✅ matchedSchemes:", matchedSchemes);
    console.log("💰 Total Payable (pre-filled):", priceBeforeDiscount);

    this.setState({
      editModalOpen: true,
      selectedRow: row,
      selectedScheme: scheme_ids,
      selectedParticipant: participant || {
        name: row?.participant_name || "",
        district: row?.district || "",
        id: row?.participant || "",
      },
      selectedPrice: priceBeforeDiscount,
    });
  };
  handleSchemeModalClose = () => {
    this.setState({
      schemeModalOpen: false,
    });
  };

  handleFilterChange = (filterName, e) => {
    const value = e.target.value;

    this.setState(
      (prevState) => ({
        [filterName]: value,

        dateToActive: filterName === "dateTo" ? true : prevState.dateToActive,
      }),
      this.checkFiltersApplied,
    );
  };
  checkFiltersApplied = () => {
    const {
      nameFilter,
      idFilter,
      districtFilter,
      schemeFilter,
      schemepriceFilter,
      amountFilter,
      discountFilter,
      TaxFilter,
      paymentsettlementFilter,
      paymentMethodFilter,
      paymentStatusFilter,
      reconcileStatusFilter,
      paidamountFilter,
      remainingAmountFilter,
      finalpayableFilter,
      dateFilter,
      paymentreceivedFilter,
      membershipStatusFilter,
      dateFrom,
      dateToActive, // Include activation flag
    } = this.state;

    // Check if ANY filter is applied AND has a NON-EMPTY value
    const filters = [
      nameFilter,
      idFilter,
      districtFilter,
      schemeFilter,
      schemepriceFilter,
      amountFilter,
      discountFilter,
      TaxFilter,
      paymentsettlementFilter,
      paymentMethodFilter,
      paymentStatusFilter,
      reconcileStatusFilter,
      paidamountFilter,
      remainingAmountFilter,
      finalpayableFilter,
      dateFilter,
      paymentreceivedFilter,
      membershipStatusFilter,
      dateFrom,
      dateToActive ? "active" : "", // Only consider dateTo if active
    ];

    const anyFilterSelected = filters.some((f) => f && f.trim() !== "");

    this.setState({ filtersApplied: anyFilterSelected });
  };

  isValidFilter = (value) => {
    return value && value !== "Select" && value !== "All";
  };

  filterData = () => {
    const {
      GetPayment,
      nameFilter = "Select",
      idFilter = "Select",
      districtFilter = "Select",
      schemeFilter = "Select",
      schemepriceFilter = "Select",
      amountFilter = "Select",
      discountFilter = "Select",
      TaxFilter = "Select",
      paymentsettlementFilter = "Select",
      paymentreceivedFilter = "Select",
      membershipStatusFilter = "Select",
      paymentMethodFilter = "Select",
      paymentStatusFilter = "Select",
      reconcileStatusFilter = "Select",
      paidamountFilter = "Select",
      remainingAmountFilter = "Select",
      finalpayableFilter = "Select",
      dateFilter = "",
      dateFrom,
      dateTo,
      dateToActive, // Include activation flag
    } = this.state;

    // Return empty array if no filters are applied
    const filters = [
      nameFilter,
      idFilter,
      districtFilter,
      schemeFilter,
      schemepriceFilter,
      amountFilter,
      discountFilter,
      TaxFilter,
      paymentsettlementFilter,
      paymentMethodFilter,
      paymentStatusFilter,
      reconcileStatusFilter,
      paidamountFilter,
      remainingAmountFilter,
      finalpayableFilter,
      dateFilter,
      paymentreceivedFilter,
      membershipStatusFilter,
      dateFrom,
      dateToActive ? dateTo : "", // Only use dateTo if active
    ];
    const isActive = (val) =>
      val !== undefined &&
      val !== null &&
      val !== "" &&
      val !== "All" &&
      val !== "Select";
    const isAnyFilterApplied = filters.some((f) => f && f !== "Select");

    // 🚫 PAGE LOAD → show nothing
    if (!isAnyFilterApplied) return [];

    return GetPayment.filter((entry) => {
      // ✅ Participant Name
      if (
        this.isValidFilter(nameFilter) &&
        !entry.participant_name
          ?.toLowerCase()
          .includes(nameFilter.toLowerCase())
      )
        return false;

      // ✅ ID
      if (
        this.isValidFilter(idFilter) &&
        !entry.id?.toString().includes(idFilter)
      )
        return false;

      // ✅ District
      if (
        this.isValidFilter(districtFilter) &&
        !entry.district?.toLowerCase().includes(districtFilter.toLowerCase())
      )
        return false;

      // ✅ Payment Status (EXACT match)
      if (
        this.isValidFilter(paymentStatusFilter) &&
        entry.payment_status !== paymentStatusFilter
      )
        return false;

      // ✅ Payment Settlement (Full / Part — exact)
      if (
        this.isValidFilter(paymentsettlementFilter) &&
        entry.payment_settlement !== paymentsettlementFilter
      )
        return false;

      // ✅ Reconcile Status
      if (this.isValidFilter(reconcileStatusFilter)) {
        const status = entry.payment_reconcile_status;
        const normalizedStatus =
          status === true || status === 1
            ? "Verified"
            : status === false || status === 0
            ? "Non-Verified"
            : status;

        if (normalizedStatus !== reconcileStatusFilter) return false;
      }
      // ✅ Scheme filter (CORRECT)
      if (isActive(schemeFilter)) {
        const schemeNames = (entry.schemes || []).map((s) => s.scheme_name);

        if (!schemeNames.includes(schemeFilter)) {
          return false;
        }
      }

      // ✅ Received By
      if (
        this.isValidFilter(paymentreceivedFilter) &&
        !entry.receivedby
          ?.toLowerCase()
          .includes(paymentreceivedFilter.toLowerCase())
      )
        return false;

      // ✅ Date filters
      if (dateFrom && new Date(entry.paydate) < new Date(dateFrom))
        return false;

      if (dateToActive && new Date(entry.paydate) > new Date(dateTo))
        return false;

      // ================= FIXED NUMERIC FILTERS =================

      // Payable (before discount)
      if (
        this.isValidFilter(schemepriceFilter) &&
        !String(entry.priceBeforeDiscount || "").includes(schemepriceFilter)
      ) {
        return false;
      }

      // Discount Amount
      if (
        this.isValidFilter(discountFilter) &&
        !String(entry.discountAmount || "").includes(discountFilter)
      ) {
        return false;
      }

      // Tax
      if (
        this.isValidFilter(TaxFilter) &&
        !String(entry.taxDeduction || "").includes(TaxFilter)
      ) {
        return false;
      }

      // ✅ Paid Amount (MATCHES UI LOGIC)
      if (this.isValidFilter(paidamountFilter)) {
        const paidAmount =
          entry.payment_settlement === "Full"
            ? entry.price
            : entry.part_payment_amount;

        if (!String(paidAmount || "").includes(paidamountFilter)) {
          return false;
        }
      }

      // Final Payable (CALCULATED SAME AS UI)
      const price = parseFloat(entry.priceBeforeDiscount) || 0;
      const discount = parseFloat(entry.discountAmount) || 0;
      const tax = parseFloat(entry.taxDeduction) || 0;

      const finalPayable = price - discount - tax;

      if (
        this.isValidFilter(finalpayableFilter) &&
        !finalPayable.toString().includes(finalpayableFilter)
      ) {
        return false;
      }

      // Remaining Amount (API VALUE — NOT RECALCULATED)
      if (
        this.isValidFilter(remainingAmountFilter) &&
        !String(entry.remaining_amount || "").includes(remainingAmountFilter)
      ) {
        return false;
      }

      return true;
    });
  };

  getUniqueOptions = (fieldName) => {
    const { GetPayment } = this.state;
    const options = new Set();

    GetPayment.forEach((item) => {
      const value = item[fieldName];
      if (Array.isArray(value)) {
        value.forEach((v) => options.add(v));
      } else if (value) {
        options.add(value);
      }
    });

    return Array.from(options);
  };
  saveFiltersToSession = () => {
    const filtersToSave = {
      nameFilter: this.state.nameFilter,
      idFilter: this.state.idFilter,
      districtFilter: this.state.districtFilter,
      schemeFilter: this.state.schemeFilter,
      schemepriceFilter: this.state.schemepriceFilter,
      discountFilter: this.state.discountFilter,
      TaxFilter: this.state.TaxFilter,
      paymentsettlementFilter: this.state.paymentsettlementFilter,
      paymentStatusFilter: this.state.paymentStatusFilter,
      reconcileStatusFilter: this.state.reconcileStatusFilter,
      paidamountFilter: this.state.paidamountFilter,
      remainingAmountFilter: this.state.remainingAmountFilter,
      finalpayableFilter: this.state.finalpayableFilter,
      dateFilter: this.state.dateFilter,
      paymentreceivedFilter: this.state.paymentreceivedFilter,
      membershipStatusFilter: this.state.membershipStatusFilter,
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo,
      dateToActive: this.state.dateToActive,
    };

    // Save filters + origin flag
    sessionStorage.setItem("PaymentCSRFilters", JSON.stringify(filtersToSave));
    sessionStorage.setItem("cameFromScheme", "true");
  };

  loadFiltersFromSession = () => {
    const cameFromScheme = sessionStorage.getItem("cameFromScheme");
    const savedFilters = sessionStorage.getItem("PaymentCSRFilters");

    if (cameFromScheme && savedFilters) {
      this.setState(JSON.parse(savedFilters));
    }

    // Always clear the flag so filters aren't restored again after refresh
    sessionStorage.removeItem("cameFromScheme");
  };
  getVerifiedPaymentsForParticipant = () => {
    const { GetPayment, activeRowId } = this.state;

    // find active payment row
    const activePayment = GetPayment.find((p) => p.id === activeRowId);
    if (!activePayment) return [];

    return GetPayment.filter(
      (p) =>
        p.participant_id === activePayment.participant_id &&
        p.payment_reconcile_status === "Verified",
    );
  };

  openParticipantModal = (row) => {
    this.setState({
      showParticipantModal: true,
      selectedParticipant: row,
    });
  };

  closeParticipantModal = () => {
    this.setState({
      showParticipantModal: false,
      selectedParticipant: null,
    });
  };

  render() {
    const schemeOptionsFromData = [
      ...new Set(
        (this.state.GetPayment || []).flatMap((row) =>
          (row.schemes || []).map((s) => s.scheme_name),
        ),
      ),
    ];
    const isAlreadyVerified = this.state.activeRowPaymentStatus === "Verified";
    const { GetPayment } = this.state;
    const defaultSorted = [{ dataField: "id", order: "desc" }];
    const filteredData = this.filterData();
    const { CycleList } = this.state;
    const { editModalOpen, selectedRow } = this.state;
    const schemeOptions = CycleList.map((scheme) => ({
      value: `${scheme.scheme_id}-${scheme.id}`,
      label: `(Scheme Name: ${scheme.scheme_name}) - (Cycle Number: ${scheme.cycle_no})`,
      scheme_id: scheme.scheme_id,
      cycle_id: scheme.id,
      remaining_round: scheme.remaining_round,
      price: parseFloat(
        (scheme.priceBeforeDiscount || scheme.price || "0")
          .toString()
          .replace(/,/g, ""),
      ),
    }));
    const verifiedPaymentIds = this.getVerifiedPaymentsForParticipant().map(
      (p) => p.id,
    );

    const filteredSchemes = (this.state.activeRowSchemes || []).filter(
      () => !verifiedPaymentIds.includes(this.state.activeRowPaymentId),
    );

    console.log("CycleList:", CycleList);
    console.log("Generated schemeOptions:", schemeOptions);
    const participant = this.state.selectedParticipant;

    console.log("FULL participant object:", participant);

    // ✅ Use the backend-provided schemes array directly
    const schemes = participant?.schemes || [];
    const schemeCount = schemes.length;

    const pageOptions = {
      sizePerPage: 50,
      totalSize: filteredData.length,
      custom: true,
      page: 1,
    };
    const customStyles = {
      // <- This is invalid here
      control: (provided) => ({
        ...provided,
        minHeight: "38px",
      }),
    };
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Participant Payment | NHS NEQAS</title>
          </MetaTags>

          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs
              title="Labs"
              breadcrumbItem="Participant-Payment Record"
            />
            <Row className="justify-content-center align-item-center">
              <p>
                <strong>Note:</strong> Payment Status is displayed in red if the
                payment is not verified, and green if verified
              </p>

              <Col lg="12">
                {" "}
                {/* <p>
                  <strong>Note:</strong> Click on Scheme Number to get detail of
                  each participants payments
                </p> */}
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={this.state.feedbackListColumns}
                      data={filteredData}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={this.state.feedbackListColumns}
                          data={filteredData}
                          search
                        >
                          {(toolkitprops) => (
                            <React.Fragment>
                              <Modal
                                isOpen={this.state.schemeModalOpen}
                                toggle={this.handleSchemeModalClose}
                                onMouseEnter={() =>
                                  clearTimeout(this.mouseExitTimeout)
                                }
                                onMouseLeave={this.handleMouseExit}
                                // className="modal-sm"
                                // size="sm"  // Change this to 'lg' or 'xl' for bigger width
                              >
                                <ModalHeader
                                  toggle={this.handleSchemeModalClose}
                                  tag="h4"
                                >
                                  Available Schemes for{" "}
                                  {this.state.hoveredParticipantName}
                                </ModalHeader>
                                <ModalBody>
                                  <ul>
                                    {this.state.hoveredSchemeNames.map(
                                      (name, index) => (
                                        <li key={index}>{name}</li>
                                      ),
                                    )}
                                  </ul>
                                </ModalBody>
                              </Modal>
                              <Modal
                                isOpen={this.state.showParticipantModal}
                                toggle={this.closeParticipantModal}
                                centered
                                size="lg"
                              >
                                <ModalHeader
                                  toggle={this.closeParticipantModal}
                                >
                                  <div>
                                    <div style={{ fontWeight: 600 }}>
                                      {this.state.selectedParticipant
                                        ?.participant_name ||
                                        "Participant Details"}
                                    </div>

                                    <div style={{ fontSize: "0.9rem" }}>
                                      Status:{" "}
                                      <span
                                        style={{
                                          fontWeight: 500,
                                          color:
                                            this.state.selectedParticipant
                                              ?.membership_status === "Active"
                                              ? "green"
                                              : this.state.selectedParticipant
                                                  ?.membership_status ===
                                                "Suspended"
                                              ? "red"
                                              : "#6c757d",
                                        }}
                                      >
                                        {this.state.selectedParticipant
                                          ?.membership_status || "-"}
                                      </span>
                                    </div>
                                  </div>
                                </ModalHeader>

                                <h5 className="ms-3">Scheme Details:</h5>

                                <ModalBody>
                                  <table className="table table-bordered table-sm mb-0 text-center">
                                    <thead>
                                      <tr>
                                        <th>Scheme Name</th>
                                        <th>Cycle No</th>
                                        <th>Remaining Rounds</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {schemes.length > 0 ? (
                                        schemes.map((scheme, index) => (
                                          <tr key={index}>
                                            <td>{scheme.scheme_name}</td>
                                            <td>{scheme.cycle_no || "-"}</td>
                                            <td>{scheme.remaining_round}</td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="3">No Schemes Found</td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </ModalBody>
                              </Modal>

                              <Row className="mb-3">
                                <Col md={4}>
                                  <Label for="nameFilter">
                                    Participant Name
                                  </Label>
                                  <Select
                                    id="nameFilter"
                                    options={[
                                      {
                                        value: "All",
                                        label: "All Participants",
                                      },
                                      ...this.getUniqueOptions(
                                        "participant_name",
                                      ).map((option) => ({
                                        value: option,
                                        label: option,
                                      })),
                                    ]}
                                    value={
                                      this.state.nameFilter
                                        ? {
                                            value: this.state.nameFilter,
                                            label: this.state.nameFilter,
                                          }
                                        : null
                                    }
                                    onChange={(selected) =>
                                      this.handleFilterChange("nameFilter", {
                                        target: {
                                          value: selected?.value || "",
                                        },
                                      })
                                    }
                                    isClearable
                                  />
                                </Col>

                                <Col md={4}>
                                  <Label>Scheme</Label>
                                  <Select
                                    options={[
                                      { value: "All", label: "All Schemes" },
                                      ...schemeOptionsFromData.map((name) => ({
                                        value: name,
                                        label: name,
                                      })),
                                    ]}
                                    value={
                                      this.state.schemeFilter
                                        ? {
                                            value: this.state.schemeFilter,
                                            label: this.state.schemeFilter,
                                          }
                                        : null
                                    }
                                    onChange={(selected) =>
                                      this.handleFilterChange("schemeFilter", {
                                        target: {
                                          value: selected?.value || "",
                                        },
                                      })
                                    }
                                    isClearable
                                  />
                                </Col>

                                <Col md={4}>
                                  <Label for="districtFilter">District</Label>
                                  <Select
                                    id="districtFilter"
                                    options={[
                                      { value: "All", label: "All Districts" },
                                      ...this.getUniqueOptions("district").map(
                                        (option) => ({
                                          value: option,
                                          label: option,
                                        }),
                                      ),
                                    ]}
                                    value={
                                      this.state.districtFilter
                                        ? {
                                            value: this.state.districtFilter,
                                            label: this.state.districtFilter,
                                          }
                                        : null
                                    }
                                    onChange={(selected) =>
                                      this.handleFilterChange(
                                        "districtFilter",
                                        {
                                          target: {
                                            value: selected?.value || "",
                                          },
                                        },
                                      )
                                    }
                                    isClearable
                                  />
                                </Col>

                                <Col md={4}>
                                  <Label for="paymentsettlementFilter">
                                    Payment Settlement
                                  </Label>
                                  <Select
                                    id="paymentsettlementFilter"
                                    options={[
                                      {
                                        value: "All",
                                        label: "All Payment Settlement",
                                      },
                                      ...this.getUniqueOptions(
                                        "payment_settlement",
                                      ).map((option) => ({
                                        value: option,
                                        label: option,
                                      })),
                                    ]}
                                    value={
                                      this.state.paymentsettlementFilter
                                        ? {
                                            value:
                                              this.state
                                                .paymentsettlementFilter,
                                            label:
                                              this.state
                                                .paymentsettlementFilter,
                                          }
                                        : null
                                    }
                                    onChange={(selected) =>
                                      this.handleFilterChange(
                                        "paymentsettlementFilter",
                                        {
                                          target: {
                                            value: selected?.value || "",
                                          },
                                        },
                                      )
                                    }
                                    isClearable
                                  />
                                </Col>

                                <Col md={4}>
                                  <Label for="paymentStatusFilter">
                                    Payment Status
                                  </Label>
                                  <Select
                                    id="paymentStatusFilter"
                                    options={[
                                      {
                                        value: "All",
                                        label: "All Payment Statuses",
                                      },
                                      ...this.getUniqueOptions(
                                        "payment_status",
                                      ).map((option) => ({
                                        value: option,
                                        label: option,
                                      })),
                                    ]}
                                    value={
                                      this.state.paymentStatusFilter
                                        ? {
                                            value:
                                              this.state.paymentStatusFilter,
                                            label:
                                              this.state.paymentStatusFilter,
                                          }
                                        : null
                                    }
                                    onChange={(selected) =>
                                      this.handleFilterChange(
                                        "paymentStatusFilter",
                                        {
                                          target: {
                                            value: selected?.value || "",
                                          },
                                        },
                                      )
                                    }
                                    isClearable
                                  />
                                </Col>
                                <Col md={4}>
                                  <Label for="reconcileStatusFilter">
                                    Verification Status
                                  </Label>
                                  <Select
                                    id="reconcileStatusFilter"
                                    options={[
                                      {
                                        value: "All",
                                        label: "All Verification Statuses",
                                      },
                                      { value: "Verified", label: "Verified" },
                                      {
                                        value: "Non-Verified",
                                        label: "Non-Verified",
                                      },
                                    ]}
                                    value={
                                      this.state.reconcileStatusFilter
                                        ? {
                                            value:
                                              this.state.reconcileStatusFilter,
                                            label:
                                              this.state
                                                .reconcileStatusFilter === "All"
                                                ? "All Verification Statuses"
                                                : this.state
                                                    .reconcileStatusFilter,
                                          }
                                        : null // ✅ MOST IMPORTANT LINE
                                    }
                                    onChange={(selected) =>
                                      this.setState({
                                        reconcileStatusFilter: selected
                                          ? selected.value
                                          : "",
                                      })
                                    }
                                    placeholder="Select Verification Status" // ✅ add this
                                    isClearable
                                  />
                                </Col>

                                <Row>
                                  <Col md={3}>
                                    <Label for="dateFrom">Payment Date</Label>
                                    <input
                                      type="date"
                                      id="dateFrom"
                                      className="form-control"
                                      value={this.state.dateFrom}
                                      onChange={(e) =>
                                        this.setState(
                                          { dateFrom: e.target.value },
                                          this.checkFiltersApplied,
                                        )
                                      }
                                    />
                                  </Col>

                                  <Col md={3}>
                                    <Label for="dateTo">Date To</Label>
                                    <input
                                      type="date"
                                      id="dateTo"
                                      className="form-control"
                                      value={this.state.dateTo}
                                      onChange={(e) =>
                                        this.setState(
                                          {
                                            dateTo: e.target.value,
                                            dateToActive: true,
                                          },
                                          this.checkFiltersApplied,
                                        )
                                      }
                                    />
                                  </Col>
                                </Row>
                              </Row>

                              <Modal
                                isOpen={this.state.showReconcileModal}
                                toggle={this.handleCloseModal}
                                centered
                                size="xl"
                              >
                                <ModalHeader toggle={this.handleCloseModal}>
                                  Verification Status –{" "}
                                  {this.state.activeParticipantName}
                                </ModalHeader>

                                <ModalBody>
                                  {/* ===== Heading ===== */}
                                  {this.getVerifiedPaymentsForParticipant()
                                    .length > 0 && (
                                    <>
                                      <h5 className="fw-bold text-dark mb-2">
                                        Details of Previous Verified Payments
                                      </h5>

                                      {/* ===== Fixed Table Section ===== */}
                                      <div
                                        style={{
                                          maxHeight: "190px",
                                          overflowY: "auto",
                                          marginBottom: "12px",
                                        }}
                                      >
                                        <table className="table table-bordered table-sm text-nowrap mb-0">
                                          <thead className="table-light">
                                            <tr style={{ fontSize: "13px" }}>
                                              <th className="text-center">
                                                Payment ID
                                              </th>
                                              <th>Payment Date</th>
                                              <th className="text-end">
                                                Paid Amount
                                              </th>
                                              <th className="text-center">
                                                Verification Status
                                              </th>
                                              <th>Verification Date</th>
                                              <th>
                                                Bank Credit / Transaction Date
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody style={{ fontSize: "13px" }}>
                                            {this.getVerifiedPaymentsForParticipant()
                                              .length > 0 ? (
                                              this.getVerifiedPaymentsForParticipant().map(
                                                (pay, index) => {
                                                  const formatDate = (date) =>
                                                    date
                                                      ? `${String(
                                                          new Date(
                                                            date,
                                                          ).getDate(),
                                                        ).padStart(
                                                          2,
                                                          "0",
                                                        )}-${new Date(
                                                          date,
                                                        ).toLocaleString(
                                                          "en-GB",
                                                          {
                                                            month: "short",
                                                          },
                                                        )}-${String(
                                                          new Date(
                                                            date,
                                                          ).getFullYear(),
                                                        ).slice(-2)}`
                                                      : "-";

                                                  return (
                                                    <tr key={index}>
                                                      <td className="text-center fw-semibold">
                                                        {pay.id || "-"}
                                                      </td>
                                                      <td>
                                                        {formatDate(
                                                          pay.paydate,
                                                        )}
                                                      </td>
                                                      <td className="text-end">
                                                        {this.formatNumber(
                                                          pay.price,
                                                        )}
                                                      </td>
                                                      <td
                                                        className="text-center"
                                                        style={{
                                                          color:
                                                            pay.payment_reconcile_status ===
                                                            "Verified"
                                                              ? "green"
                                                              : "red",
                                                          fontWeight: 600,
                                                        }}
                                                      >
                                                        {pay.payment_reconcile_status ||
                                                          "Non-Verified"}
                                                      </td>
                                                      <td>
                                                        {formatDate(
                                                          pay.reconciled_at,
                                                        )}
                                                      </td>
                                                      <td>
                                                        {formatDate(
                                                          pay.payment_received_date,
                                                        )}
                                                      </td>
                                                    </tr>
                                                  );
                                                },
                                              )
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan="6"
                                                  className="text-center text-muted"
                                                >
                                                  No verified payments for this
                                                  Lab
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                      <hr className="my-3" />
                                    </>
                                  )}

                                  {/* ===== New Payment Table ===== */}
                                  {filteredSchemes.length > 0 && (
                                    <>
                                      <h5 className="fw-bold text-dark mb-2">
                                        New Payment to be Verified
                                      </h5>

                                      <div className="mb-3">
                                        <table className="table table-bordered table-sm text-nowrap mb-0">
                                          <thead className="table-light">
                                            <tr style={{ fontSize: "13px" }}>
                                              <th className="text-center">
                                                Payment ID
                                              </th>
                                              <th>Payment Date</th>
                                              <th className="text-end">
                                                Paid Amount
                                              </th>
                                              <th>Verification Status</th>
                                              <th>Verification Date</th>
                                              <th>Bank / Transaction Date</th>
                                            </tr>
                                          </thead>

                                          <tbody style={{ fontSize: "13px" }}>
                                            {/* Only one row per payment */}
                                            {filteredSchemes.length > 0 &&
                                              (() => {
                                                const payDate = this.state
                                                  .activeRowPaymentDate
                                                  ? new Date(
                                                      this.state.activeRowPaymentDate,
                                                    )
                                                  : null;

                                                const formattedDate = payDate
                                                  ? `${String(
                                                      payDate.getDate(),
                                                    ).padStart(
                                                      2,
                                                      "0",
                                                    )}-${payDate.toLocaleString(
                                                      "en-GB",
                                                      { month: "short" },
                                                    )}-${String(
                                                      payDate.getFullYear(),
                                                    ).slice(-2)}`
                                                  : "-";

                                                return (
                                                  <tr>
                                                    <td className="text-center fw-semibold">
                                                      {this.state
                                                        .activeRowPaymentId ||
                                                        "-"}
                                                    </td>
                                                    <td>{formattedDate}</td>
                                                    <td className="text-end">
                                                      {this.state
                                                        .activeRowPaidAmount ||
                                                        "-"}
                                                    </td>
                                                    <td
                                                      style={{
                                                        color:
                                                          this.state
                                                            .activeRowPaymentStatus ===
                                                          "Verified"
                                                            ? "green"
                                                            : "red",
                                                        fontWeight: 600,
                                                      }}
                                                    >
                                                      {this.state
                                                        .activeRowPaymentStatus ||
                                                        "Non-Verified"}
                                                    </td>
                                                    <td>-</td>
                                                    <td>
                                                      {this.state
                                                        .paymentReceivedDate ||
                                                        "-"}
                                                    </td>
                                                  </tr>
                                                );
                                              })()}
                                          </tbody>
                                        </table>
                                      </div>
                                    </>
                                  )}

                                  {/* ===== Summary ===== */}
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginBottom: "12px",
                                    }}
                                  >
                                    <b>Final Payable:</b>{" "}
                                    {this.state.activeRowPayable || "-"}{" "}
                                    &nbsp;|&nbsp;
                                    <b>Payment Mode:</b>{" "}
                                    {this.state.activeRowPaymentMode || "-"}
                                  </div>

                                  {/* ===== Verification Form ===== */}
                                  <div className="mb-2">
                                    <Select
                                      options={[
                                        {
                                          value: "Verified",
                                          label: "Verified",
                                        },
                                        {
                                          value: "Non-Verified",
                                          label: "Non-Verified",
                                        },
                                      ]}
                                      value={
                                        this.state.pendingReconcileStatus
                                          ? {
                                              value:
                                                this.state
                                                  .pendingReconcileStatus,
                                              label:
                                                this.state
                                                  .pendingReconcileStatus,
                                            }
                                          : null
                                      }
                                      onChange={(selected) =>
                                        this.setState({
                                          pendingReconcileStatus: selected
                                            ? selected.value
                                            : null,
                                        })
                                      }
                                      placeholder="Select Verification Status"
                                      isDisabled={isAlreadyVerified} // 🔒 lock dropdown if verified
                                      isClearable={!isAlreadyVerified}
                                    />
                                  </div>

                                  {this.state.pendingReconcileStatus ===
                                    "Verified" && (
                                    <>
                                      {/* Account Number */}
                                      <div className="mb-2">
                                        <label className="fw-bold">
                                          Select Account Number
                                        </label>

                                        <Select
                                          options={(
                                            this.props.ListBank || []
                                          ).map((bank) => ({
                                            value: bank.account_number,
                                            label: `${bank.account_number} (${bank.name})`,
                                          }))}
                                          value={
                                            this.state
                                              .pendingSelectedAccountNumber
                                              ? {
                                                  value:
                                                    this.state
                                                      .pendingSelectedAccountNumber,
                                                  label: `${this.state.pendingSelectedAccountNumber} (${this.state.pendingBankName})`,
                                                }
                                              : null
                                          }
                                          onChange={(selected) =>
                                            this.setState({
                                              pendingSelectedAccountNumber:
                                                selected?.value || "",
                                              pendingBankName:
                                                selected?.label
                                                  ?.split(" (")[1]
                                                  ?.replace(")", "") || "",
                                            })
                                          }
                                          isDisabled={isAlreadyVerified} // 🔒 disable if verified
                                          isClearable
                                        />
                                      </div>

                                      {/* Bank Credit Date */}

                                      {!isAlreadyVerified && (
                                        <div className="mb-2">
                                          <label className="fw-bold">
                                            Bank Credit / Transaction Date
                                          </label>
                                          <input
                                            type="date"
                                            className="form-control"
                                            max={
                                              new Date()
                                                .toISOString()
                                                .split("T")[0]
                                            }
                                            value={
                                              this.state
                                                .pendingPaymentReceivedDate ||
                                              ""
                                            }
                                            onChange={(e) =>
                                              this.setState({
                                                pendingPaymentReceivedDate:
                                                  e.target.value,
                                              })
                                            }
                                          />
                                        </div>
                                      )}

                                      {/* Attachment */}
                                      <div className="mb-2">
                                        <label className="fw-bold">
                                          Attach Image
                                        </label>
                                        {this.state.pendingUploadedImage &&
                                          typeof this.state
                                            .pendingUploadedImage ===
                                            "string" && (
                                            <div className="mb-1">
                                              <a
                                                href={
                                                  this.state
                                                    .pendingUploadedImage
                                                }
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                View Existing Attachment
                                              </a>
                                            </div>
                                          )}
                                        <input
                                          type="file"
                                          className="form-control"
                                          accept="image/*"
                                          onChange={(e) =>
                                            this.setState({
                                              pendingUploadedImage:
                                                e.target.files[0],
                                            })
                                          }
                                          disabled={isAlreadyVerified} // 🔒 disable if verified
                                        />
                                      </div>

                                      {/* Comments */}
                                      <div className="mb-2">
                                        <label className="fw-bold">
                                          Add Comments
                                        </label>
                                        <textarea
                                          className="form-control"
                                          rows="2"
                                          placeholder="Enter any comments..."
                                          value={
                                            this.state.pendingComments || ""
                                          }
                                          onChange={(e) =>
                                            this.setState({
                                              pendingComments: e.target.value,
                                            })
                                          }
                                          disabled={isAlreadyVerified} // 🔒 disable if verified
                                        />
                                      </div>
                                    </>
                                  )}

                                  {/* Verify Button */}
                                  {!isAlreadyVerified && (
                                    <div className="text-end mt-3">
                                      <Button
                                        color="primary"
                                        size="sm"
                                        disabled={
                                          this.state.pendingReconcileStatus !==
                                            "Verified" ||
                                          (!this.state
                                            .pendingSelectedAccountNumber &&
                                            this.state.activeRowPayable > 0) ||
                                          !this.state.pendingPaymentReceivedDate
                                        }
                                        onClick={this.handleReconcileSubmit}
                                      >
                                        Verify
                                      </Button>
                                    </div>
                                  )}

                                  {/* Already Verified Notice */}
                                  {isAlreadyVerified && (
                                    <div className="text-muted mt-3">
                                      ✅ This payment is already verified and is
                                      read-only.
                                    </div>
                                  )}
                                </ModalBody>
                              </Modal>

                              <Modal
                                isOpen={this.state.showReconcileDetailsModal}
                                toggle={() =>
                                  this.setState({
                                    showReconcileDetailsModal: false,
                                  })
                                }
                                centered
                              >
                                <ModalHeader
                                  toggle={() =>
                                    this.setState({
                                      showReconcileDetailsModal: false,
                                    })
                                  }
                                >
                                  Verification Details –{" "}
                                  {this.state.selectedPayment?.participant_name}
                                </ModalHeader>

                                <ModalBody>
                                  {this.state.selectedPayment ? (
                                    <table className="table table-bordered table-striped">
                                      <tbody>
                                        <tr>
                                          <td className="text-start">
                                            <strong>Status</strong>
                                          </td>
                                          <td className="text-start">
                                            {this.state.selectedPayment
                                              .payment_reconcile_status || "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-start">
                                            <strong>Account Number</strong>
                                          </td>
                                          <td className="text-start">
                                            {this.state.selectedPayment
                                              .account_number || "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-start">
                                            <strong>Bank Name</strong>
                                          </td>
                                          <td className="text-start">
                                            {this.state.selectedPayment
                                              .bank_name || "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-start">
                                            <strong>Bank Credit Date</strong>
                                          </td>
                                          <td className="text-start">
                                            {this.state.selectedPayment
                                              .payment_received_date
                                              ? new Date(
                                                  this.state.selectedPayment.payment_received_date,
                                                ).toLocaleDateString("en-GB", {
                                                  day: "2-digit",
                                                  month: "short",
                                                  year: "numeric",
                                                })
                                              : "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-start">
                                            <strong>Comments</strong>
                                          </td>
                                          <td className="text-start">
                                            {this.state.selectedPayment
                                              .comments || "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-start">
                                            <strong>Attachment</strong>
                                          </td>
                                          <td className="text-start">
                                            {this.state.selectedPayment
                                              ?.attachment_url ? (
                                              <a
                                                href={
                                                  this.state.selectedPayment
                                                    .attachment_url
                                                }
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                View Attachment
                                              </a>
                                            ) : (
                                              "-"
                                            )}
                                          </td>
                                        </tr>

                                        <tr>
                                          <td className="text-start">
                                            <strong>Verified By</strong>
                                          </td>
                                          <td className="text-start">
                                            {this.state.selectedPayment
                                              .added_by_name || "-"}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="text-start">
                                            <strong>Verified At</strong>
                                          </td>
                                          <td className="text-start">
                                            {this.state.selectedPayment
                                              .reconciled_at
                                              ? new Date(
                                                  this.state.selectedPayment.reconciled_at,
                                                ).toLocaleDateString("en-GB", {
                                                  day: "numeric",
                                                  month: "short",
                                                  year: "numeric",
                                                })
                                              : "-"}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  ) : (
                                    <p>No details found.</p>
                                  )}
                                </ModalBody>
                              </Modal>
                              <Modal
                                isOpen={this.state.editModalOpen}
                                toggle={this.toggleEditModal}
                                size="md"
                              >
                                <ModalHeader
                                  toggle={() =>
                                    this.setState({ editModalOpen: false })
                                  }
                                >
                                  Update Payment for{" "}
                                  {this.state.selectedRow?.participant_name ||
                                    "Unknown"}
                                </ModalHeader>

                                <ModalBody>
                                  {this.state.selectedRow && (
                                    <Formik
                                      initialValues={{
                                        participant_name:
                                          this.state.selectedRow
                                            .participant_name,
                                        // scheme: [],
                                        scheme: this.state.selectedScheme,
                                        participant:
                                          this.state.selectedParticipant?.id ||
                                          "",
                                        // scheme: [],
                                        district:
                                          this.state.selectedParticipant
                                            ?.district || "",
                                        membership_status:
                                          this.state.selectedRow
                                            .membership_status,
                                        priceBeforeDiscount:
                                          this.state.selectedPrice,
                                        discountAmount:
                                          this.state.selectedRow.discountAmount,
                                        discount:
                                          this.state.selectedRow
                                            ?.discountAmount &&
                                          this.state.selectedPrice
                                            ? (
                                                (parseFloat(
                                                  this.state.selectedRow
                                                    .discountAmount,
                                                ) *
                                                  100) /
                                                parseFloat(
                                                  this.state.selectedPrice,
                                                )
                                              ).toFixed(2)
                                            : "",
                                        taxDeduction:
                                          this.state.selectedRow.taxDeduction,
                                        price: this.state.selectedRow.price,
                                        payment_settlement:
                                          this.state.selectedRow
                                            .payment_settlement,
                                        part_payment_amount:
                                          this.state.selectedRow
                                            .part_payment_amount,
                                        remaining_amount:
                                          this.state.selectedRow
                                            .remaining_amount,
                                        paymentmethod:
                                          this.state.selectedRow.paymentmethod,
                                        payment_status:
                                          this.state.selectedRow.payment_status,
                                        paydate:
                                          this.state.selectedRow?.paydate &&
                                          this.state.selectedRow.paydate !==
                                            "null"
                                            ? this.state.selectedRow.paydate
                                            : "",
                                        receivedby:
                                          this.state.selectedRow.receivedby,
                                      }}
                                      onSubmit={(values, { setSubmitting }) => {
                                        const selectedSchemeDetails = (
                                          values.scheme || []
                                        ).map((id) => {
                                          const [scheme_id, cycle_id] =
                                            id.split("-");
                                          return this.state.CycleList.find(
                                            (scheme) =>
                                              String(scheme.scheme_id) ===
                                                scheme_id &&
                                              String(scheme.id) === cycle_id,
                                          );
                                        });

                                        const totalPriceBeforeDiscount =
                                          selectedSchemeDetails.reduce(
                                            (sum, scheme) => {
                                              const raw =
                                                scheme?.priceBeforeDiscount ??
                                                scheme?.price ??
                                                0;
                                              const cleaned = parseFloat(
                                                raw
                                                  .toString()
                                                  .replace(/,/g, ""),
                                              );
                                              return (
                                                sum +
                                                (isNaN(cleaned) ? 0 : cleaned)
                                              );
                                            },
                                            0,
                                          );

                                        const payload = {
                                          ...values,
                                          scheme: values.scheme.join(","),
                                          id: this.state.selectedRow?.id,
                                          added_by: this.state.user_id,
                                          participant:
                                            this.state.selectedRow
                                              ?.participant ||
                                            values.participant,
                                          priceBeforeDiscount: parseFloat(
                                            totalPriceBeforeDiscount
                                              .toString()
                                              .replace(/,/g, ""),
                                          ).toFixed(2),
                                          // ✅ actual scheme price
                                        };
                                        console.log(
                                          "✅ Final priceBeforeDiscount to send:",
                                          totalPriceBeforeDiscount,
                                        );
                                        this.props.onupdatePayment(payload);

                                        setTimeout(() => {
                                          if (this.state.user_id) {
                                            this.props.onGetParticipantpayment(
                                              this.state.user_id,
                                            );
                                          }
                                        }, 500);

                                        this.setState({ editModalOpen: false });
                                      }}
                                    >
                                      {({
                                        values,
                                        setFieldValue,
                                        isSubmitting,
                                        errors,
                                        touched,
                                      }) => (
                                        <Form>
                                          {/* {(() => {
                                            if (
                                              values.scheme &&
                                              values.scheme.length > 0
                                            ) {
                                              const selectedSchemeDetails =
                                                values.scheme.map(id => {
                                                  const [scheme_id, cycle_id] =
                                                    id.split("-");
                                                  return this.state.CycleList.find(
                                                    scheme =>
                                                      String(
                                                        scheme.scheme_id
                                                      ) === scheme_id &&
                                                      String(scheme.id) ===
                                                        cycle_id
                                                  );
                                                });

                                              const total =
                                                selectedSchemeDetails.reduce(
                                                  (sum, scheme) => {
                                                    return (
                                                      sum +
                                                      (scheme?.price
                                                        ? parseFloat(
                                                            scheme.price
                                                          )
                                                        : 0)
                                                    );
                                                  },
                                                  0
                                                );

                                              if (
                                                values.priceBeforeDiscount !==
                                                total.toFixed(2)
                                              ) {
                                                setFieldValue(
                                                  "priceBeforeDiscount",
                                                  total.toFixed(2)
                                                );
                                                setFieldValue(
                                                  "price",
                                                  total.toFixed(2)
                                                ); // Optional: update final payable
                                              }
                                            }
                                          })()} */}
                                          <Row>
                                            {/* <Col md="6">
                                              <Label>Participant Name</Label>
                                              <Field
                                                name="participant_name"
                                                className="form-control"
                                              />
                                            </Col> */}
                                            <Row>
                                              <Col>
                                                <Label>Scheme</Label>
                                                <Select
                                                  name="scheme"
                                                  isMulti
                                                  options={schemeOptions}
                                                  placeholder={
                                                    this.state.selectedRow?.scheme_names?.join(
                                                      ", ",
                                                    ) || "Select schemes"
                                                  }
                                                  value={schemeOptions.filter(
                                                    (option) =>
                                                      (
                                                        values.scheme || []
                                                      ).includes(option.value),
                                                  )}
                                                  onChange={(
                                                    selectedOptions,
                                                  ) => {
                                                    const selectedValues =
                                                      selectedOptions
                                                        ? selectedOptions.map(
                                                            (option) =>
                                                              option.value,
                                                          )
                                                        : [];
                                                    setFieldValue(
                                                      "scheme",
                                                      selectedValues,
                                                    );

                                                    // ✅ Calculate total price from selected schemes
                                                    const total =
                                                      selectedOptions.reduce(
                                                        (sum, option) => {
                                                          const raw =
                                                            option.price || 0;
                                                          const num =
                                                            parseFloat(
                                                              raw
                                                                .toString()
                                                                .replace(
                                                                  /,/g,
                                                                  "",
                                                                ),
                                                            );
                                                          return (
                                                            sum +
                                                            (isNaN(num)
                                                              ? 0
                                                              : num)
                                                          );
                                                        },
                                                        0,
                                                      );

                                                    // ✅ Set both base and final price correctly
                                                    setFieldValue(
                                                      "priceBeforeDiscount",
                                                      total.toFixed(2),
                                                    ); // <- this was missing
                                                    const discount =
                                                      parseFloat(
                                                        values.discountAmount,
                                                      ) || 0;
                                                    const tax =
                                                      parseFloat(
                                                        values.taxDeduction,
                                                      ) || 0;
                                                    const finalPayable =
                                                      total - discount - tax;

                                                    setFieldValue(
                                                      "price",
                                                      finalPayable.toFixed(2),
                                                    );
                                                  }}
                                                />
                                              </Col>
                                            </Row>
                                            <Col>
                                              <div className="mb-3">
                                                <Label
                                                  htmlFor="priceBeforeDiscount"
                                                  className="form-label"
                                                >
                                                  Payable
                                                </Label>
                                                <Field name="priceBeforeDiscount">
                                                  {({ field }) => {
                                                    const value = Number(
                                                      (
                                                        values.priceBeforeDiscount ||
                                                        "0"
                                                      )
                                                        .toString()
                                                        .replace(/,/g, ""),
                                                    );
                                                    return (
                                                      <input
                                                        {...field}
                                                        type="text"
                                                        className="form-control"
                                                        value={
                                                          typeof value ===
                                                          "number"
                                                            ? value.toLocaleString(
                                                                "en-PK",
                                                              )
                                                            : value
                                                        }
                                                        readOnly
                                                        style={{
                                                          backgroundColor:
                                                            "#e9ecef",
                                                        }}
                                                      />
                                                    );
                                                  }}
                                                </Field>
                                                <ErrorMessage
                                                  name="priceBeforeDiscount"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </div>
                                            </Col>
                                          </Row>

                                          <Row className="mt-3">
                                            {/* <Col md="6">
                                              <Label>Membership Status</Label>
                                              <Field
                                                name="membership_status"
                                                className="form-control"
                                              />
                                            </Col> */}
                                            <Col md={6}>
                                              <Label>Discount in (%)</Label>
                                              <Field name="discount">
                                                {({ field }) => (
                                                  <input
                                                    {...field}
                                                    type="text"
                                                    className="form-control"
                                                    onChange={(e) => {
                                                      const discountPercent =
                                                        parseFloat(
                                                          e.target.value,
                                                        );
                                                      setFieldValue(
                                                        "discount",
                                                        e.target.value,
                                                      );

                                                      // Always read original price from priceBeforeDiscount only
                                                      const basePrice =
                                                        parseFloat(
                                                          values.priceBeforeDiscount,
                                                        ) || 0;

                                                      if (
                                                        !isNaN(discountPercent)
                                                      ) {
                                                        const discountAmount =
                                                          (basePrice *
                                                            discountPercent) /
                                                          100;
                                                        const tax = parseFloat(
                                                          values.taxDeduction ||
                                                            0,
                                                        );
                                                        const finalPrice =
                                                          basePrice -
                                                          discountAmount -
                                                          tax;

                                                        setFieldValue(
                                                          "discountAmount",
                                                          discountAmount.toFixed(
                                                            2,
                                                          ),
                                                        );
                                                        setFieldValue(
                                                          "price",
                                                          finalPrice.toFixed(2),
                                                        );
                                                      } else {
                                                        // If cleared, also clear discountAmount
                                                        setFieldValue(
                                                          "discountAmount",
                                                          "",
                                                        );
                                                        const tax = parseFloat(
                                                          values.taxDeduction ||
                                                            0,
                                                        );
                                                        setFieldValue(
                                                          "price",
                                                          (
                                                            basePrice - tax
                                                          ).toFixed(2),
                                                        );
                                                      }
                                                    }}
                                                  />
                                                )}
                                              </Field>
                                              <ErrorMessage
                                                name="discount"
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </Col>

                                            <Col md={6}>
                                              <Label>
                                                Discount Amount (Rs)
                                              </Label>
                                              <Field name="discountAmount">
                                                {({ field }) => (
                                                  <input
                                                    {...field}
                                                    type="text"
                                                    className="form-control"
                                                    value={field.value || ""}
                                                    onChange={(e) => {
                                                      const discountAmount =
                                                        parseFloat(
                                                          e.target.value,
                                                        );
                                                      setFieldValue(
                                                        "discountAmount",
                                                        e.target.value,
                                                      );

                                                      const payableBeforeDiscount =
                                                        parseFloat(
                                                          values.priceBeforeDiscount ||
                                                            values.price,
                                                        ) || 0;

                                                      if (
                                                        !isNaN(
                                                          discountAmount,
                                                        ) &&
                                                        payableBeforeDiscount >
                                                          0
                                                      ) {
                                                        const percent =
                                                          (discountAmount /
                                                            payableBeforeDiscount) *
                                                          100;
                                                        const tax = parseFloat(
                                                          values.taxDeduction ||
                                                            0,
                                                        );
                                                        const finalPrice =
                                                          payableBeforeDiscount -
                                                          discountAmount -
                                                          tax;

                                                        setFieldValue(
                                                          "discount",
                                                          percent.toFixed(2),
                                                        );
                                                        setFieldValue(
                                                          "price",
                                                          finalPrice.toFixed(2),
                                                        );
                                                      } else {
                                                        // If cleared, also clear discount percent
                                                        setFieldValue(
                                                          "discount",
                                                          "",
                                                        );
                                                        const tax = parseFloat(
                                                          values.taxDeduction ||
                                                            0,
                                                        );
                                                        setFieldValue(
                                                          "price",
                                                          (
                                                            payableBeforeDiscount -
                                                            tax
                                                          ).toFixed(2),
                                                        );
                                                      }
                                                    }}
                                                  />
                                                )}
                                              </Field>
                                              <ErrorMessage
                                                name="discountAmount"
                                                component="div"
                                                className="invalid-feedback"
                                              />
                                            </Col>

                                            <Row>
                                              <Col>
                                                <Label>
                                                  Tax Deduction Amount
                                                </Label>
                                                <Field name="taxDeduction">
                                                  {({ field }) => (
                                                    <input
                                                      {...field}
                                                      type="text"
                                                      className="form-control"
                                                      placeholder="Enter tax deduction amount"
                                                      onChange={(e) => {
                                                        const tax = parseFloat(
                                                          e.target.value,
                                                        );
                                                        setFieldValue(
                                                          "taxDeduction",
                                                          e.target.value,
                                                        );

                                                        const payable =
                                                          parseFloat(
                                                            values.priceBeforeDiscount ||
                                                              values.price,
                                                          ) || 0;
                                                        const discount =
                                                          parseFloat(
                                                            values.discountAmount,
                                                          ) || 0;
                                                        if (!isNaN(tax)) {
                                                          const finalPrice =
                                                            payable -
                                                            discount -
                                                            tax;
                                                          setFieldValue(
                                                            "price",
                                                            finalPrice.toFixed(
                                                              2,
                                                            ),
                                                          );
                                                        }
                                                      }}
                                                    />
                                                  )}
                                                </Field>
                                                <ErrorMessage
                                                  name="taxDeduction"
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </Col>
                                              <Row>
                                                <Col>
                                                  <Label>Payment Status</Label>
                                                  <Select
                                                    name="payment_status"
                                                    options={[
                                                      {
                                                        value: "Paid",
                                                        label: "Paid",
                                                      },
                                                      {
                                                        value:
                                                          "Payment In process",
                                                        label:
                                                          "Payment In process",
                                                      },
                                                    ]}
                                                    onChange={(
                                                      selectedOption,
                                                    ) => {
                                                      const status =
                                                        selectedOption?.value ||
                                                        "";
                                                      setFieldValue(
                                                        "payment_status",
                                                        status,
                                                      );

                                                      if (
                                                        status === "Paid" ||
                                                        status ===
                                                          "Payment In process"
                                                      ) {
                                                        setFieldValue(
                                                          "is_active",
                                                          true,
                                                        );
                                                      }
                                                    }}
                                                    value={
                                                      values.payment_status
                                                        ? {
                                                            value:
                                                              values.payment_status,
                                                            label:
                                                              values.payment_status,
                                                          }
                                                        : null
                                                    }
                                                    placeholder="Select"
                                                    className={
                                                      errors.payment_status &&
                                                      touched.payment_status
                                                        ? "is-invalid"
                                                        : ""
                                                    }
                                                  />
                                                  <ErrorMessage
                                                    name="payment_status"
                                                    component="div"
                                                    className="invalid-feedback"
                                                  />
                                                </Col>
                                                {values.payment_status ===
                                                  "Payment In process" && (
                                                  <div className="form-group">
                                                    <label>
                                                      Upload Copy of Purchase
                                                      Order
                                                    </label>
                                                    <input
                                                      type="file"
                                                      name="purchase_order_copy"
                                                      onChange={(event) =>
                                                        setFieldValue(
                                                          "purchase_order_copy",
                                                          event.currentTarget
                                                            .files[0],
                                                        )
                                                      }
                                                      className="form-control"
                                                    />
                                                    {errors.purchase_order_copy &&
                                                      touched.purchase_order_copy && (
                                                        <div className="text-danger">
                                                          {
                                                            errors.purchase_order_copy
                                                          }
                                                        </div>
                                                      )}
                                                  </div>
                                                )}
                                              </Row>
                                              {values.payment_status ===
                                                "Paid" && (
                                                <>
                                                  <Row>
                                                    <Col>
                                                      <div className="mb-3">
                                                        <Label
                                                          htmlFor="price"
                                                          className="form-label"
                                                        >
                                                          Payable after Discount
                                                          & Tax Deduction
                                                        </Label>
                                                        <Field name="price">
                                                          {({ field }) => (
                                                            <input
                                                              {...field}
                                                              type="text"
                                                              className="form-control"
                                                              value={new Intl.NumberFormat(
                                                                "en-PK",
                                                                {
                                                                  style:
                                                                    "currency",
                                                                  currency:
                                                                    "PKR",
                                                                },
                                                              ).format(
                                                                values.price ||
                                                                  0,
                                                              )}
                                                              readOnly
                                                              style={{
                                                                backgroundColor:
                                                                  "#e9ecef",
                                                              }}
                                                            />
                                                          )}
                                                        </Field>
                                                        <ErrorMessage
                                                          name="price"
                                                          component="div"
                                                          className="invalid-feedback"
                                                        />
                                                      </div>
                                                    </Col>
                                                  </Row>

                                                  <Col>
                                                    <Label>
                                                      Payment Settlement
                                                    </Label>
                                                    <Select
                                                      name="payment_settlement"
                                                      options={[
                                                        {
                                                          value: "Full",
                                                          label: "Full",
                                                        },
                                                        {
                                                          value: "Part",
                                                          label: "Part",
                                                        },
                                                      ]}
                                                      onChange={(
                                                        selectedOption,
                                                      ) => {
                                                        const settlement =
                                                          selectedOption?.value ||
                                                          "";
                                                        setFieldValue(
                                                          "payment_settlement",
                                                          settlement,
                                                        );
                                                        if (
                                                          settlement ===
                                                            "Full" ||
                                                          settlement === "Part"
                                                        ) {
                                                          setFieldValue(
                                                            "is_active",
                                                            true,
                                                          );
                                                        }
                                                      }}
                                                      value={
                                                        values.payment_settlement
                                                          ? {
                                                              value:
                                                                values.payment_settlement,
                                                              label:
                                                                values.payment_settlement,
                                                            }
                                                          : null
                                                      }
                                                      placeholder="Select"
                                                      className={
                                                        errors.payment_settlement &&
                                                        touched.payment_settlement
                                                          ? "is-invalid"
                                                          : ""
                                                      }
                                                    />
                                                    <ErrorMessage
                                                      name="payment_settlement"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </Col>

                                                  {values.payment_settlement ===
                                                    "Part" && (
                                                    <>
                                                      <Col className="mt-3">
                                                        <Label>
                                                          Part Payment Amount
                                                        </Label>
                                                        <Field name="part_payment_amount">
                                                          {({ field }) => (
                                                            <input
                                                              {...field}
                                                              type="number"
                                                              className={
                                                                errors.part_payment_amount &&
                                                                touched.part_payment_amount
                                                                  ? "form-control is-invalid"
                                                                  : "form-control"
                                                              }
                                                              value={
                                                                field.value ===
                                                                  undefined ||
                                                                field.value ===
                                                                  null ||
                                                                field.value ===
                                                                  ""
                                                                  ? 0
                                                                  : field.value
                                                              }
                                                              onChange={(e) => {
                                                                const input =
                                                                  e.target
                                                                    .value;
                                                                const partAmount =
                                                                  parseFloat(
                                                                    input,
                                                                  ) || 0;
                                                                const totalAmount =
                                                                  parseFloat(
                                                                    values.price,
                                                                  ) || 0;
                                                                const remaining =
                                                                  totalAmount -
                                                                  partAmount;

                                                                setFieldValue(
                                                                  "part_payment_amount",
                                                                  input === ""
                                                                    ? 0
                                                                    : input,
                                                                );
                                                                setFieldValue(
                                                                  "remaining_amount",
                                                                  remaining >= 0
                                                                    ? remaining
                                                                    : 0,
                                                                );
                                                              }}
                                                            />
                                                          )}
                                                        </Field>
                                                        <ErrorMessage
                                                          name="part_payment_amount"
                                                          component="div"
                                                          className="invalid-feedback"
                                                        />
                                                      </Col>

                                                      <Col className="mt-3">
                                                        <Label>
                                                          Remaining Amount
                                                        </Label>
                                                        <Field
                                                          name="remaining_amount"
                                                          type="number"
                                                          disabled
                                                          className="form-control"
                                                        />
                                                      </Col>
                                                    </>
                                                  )}
                                                  <Row>
                                                    <Col>
                                                      <Label>Pay Date</Label>
                                                      <Field
                                                        name="paydate"
                                                        type="date"
                                                        className="form-control"
                                                      />
                                                      <ErrorMessage
                                                        name="paydate"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </Col>
                                                  </Row>

                                                  <Row>
                                                    <Col>
                                                      <Label>Pay Copy</Label>
                                                      <Input
                                                        id="formFile"
                                                        name="photo"
                                                        type="file"
                                                        multiple={false}
                                                        accept=".jpg,.jpeg,.png,.pdf"
                                                        onChange={(event) =>
                                                          this.handleFileChange(
                                                            event,
                                                            setFieldValue,
                                                          )
                                                        }
                                                        className={
                                                          "form-control" +
                                                          (errors.photo &&
                                                          touched.photo
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                      />
                                                      <small
                                                        style={{
                                                          color: "#007bff",
                                                        }}
                                                      >
                                                        Only JPEG, PNG, or PDF
                                                        files up to 2MB in size
                                                        are allowed.
                                                      </small>
                                                      <ErrorMessage
                                                        name="photo"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />

                                                      {/* 🔽 Add this below the input field */}
                                                      {this.state.selectedRow
                                                        ?.photo_url && (
                                                        <div className="mt-2">
                                                          <a
                                                            href={
                                                              this.state
                                                                .selectedRow
                                                                .photo_url
                                                            }
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-primary"
                                                          >
                                                            View Previously
                                                            Uploaded Pay Copy
                                                          </a>
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>

                                                  <Row>
                                                    <Col>
                                                      <Label>
                                                        Payment Method
                                                      </Label>
                                                      <Select
                                                        name="paymentmethod"
                                                        options={[
                                                          {
                                                            value: "Online",
                                                            label: "Online",
                                                          },
                                                          {
                                                            value: "Cheque",
                                                            label: "Cheque",
                                                          },
                                                          {
                                                            value: "Cash",
                                                            label: "Cash",
                                                          },
                                                        ]}
                                                        onChange={(
                                                          selectedOption,
                                                        ) =>
                                                          setFieldValue(
                                                            "paymentmethod",
                                                            selectedOption?.value ||
                                                              "",
                                                          )
                                                        }
                                                        value={
                                                          values.paymentmethod
                                                            ? {
                                                                value:
                                                                  values.paymentmethod,
                                                                label:
                                                                  values.paymentmethod,
                                                              }
                                                            : null
                                                        }
                                                        className={
                                                          errors.paymentmethod &&
                                                          touched.paymentmethod
                                                            ? "is-invalid"
                                                            : ""
                                                        }
                                                      />
                                                      <ErrorMessage
                                                        name="paymentmethod"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </Col>
                                                  </Row>

                                                  <Row>
                                                    <Col>
                                                      <Label>Received By</Label>
                                                      <Field
                                                        name="receivedby"
                                                        type="text"
                                                        className="form-control"
                                                      />
                                                      <ErrorMessage
                                                        name="receivedby"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </Col>
                                                  </Row>
                                                </>
                                              )}
                                            </Row>
                                          </Row>

                                          <div className="mt-4 text-end">
                                            <button
                                              type="submit"
                                              className="btn btn-primary"
                                              disabled={isSubmitting}
                                            >
                                              Save Changes
                                            </button>
                                          </div>
                                        </Form>
                                      )}
                                    </Formik>
                                  )}
                                </ModalBody>
                              </Modal>
                              <Row className="mb-4">
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      key={this.state.tableKey} // ✅ This is critical!
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={"table align-middle"}
                                      bordered={false}
                                      striped={false}
                                      headerWrapperClasses={"table-light"}
                                      responsive
                                      ref={this.node}
                                      filter={filterFactory()} // Ensure filterFactory is applied correctly
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ParticipantPayments.propTypes = {
  GetPayment: PropTypes.array,
  onGetParticipantpayment: PropTypes.func,
  onconfirmpayment: PropTypes.func,
  ongetcyclelist: PropTypes.func,
  CycleList: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  confirmpayment: PropTypes.array,
  ListBank: PropTypes.array,
  onGetBankList: PropTypes.func,
  onupdatePayment: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => {
  const cycleList = state.CycleList?.CycleList || [];
  const ListDistrict = state.ListDistrict?.ListDistrict || [];

  console.log("CycleList:", cycleList);
  console.log("ListDistrict:", ListDistrict);

  return {
    userID: state.Account?.userID || null,
    CycleList: cycleList, // ✅ FIXED
    PaymentSchemeList: state.PaymentScheme?.PaymentSchemeList || [],
    GetPayment: state.AddPayment?.GetPayment ?? [],
    ListBank: state.banks?.ListBank || [], // ✅ Always return array
    ListDistrict, // Field name matches return object
  };
};

const mapDispatchToProps = (dispatch) => ({
  onGetParticipantpayment: () => dispatch(getParticipantPayment()),
  ongetcyclelist: (id) => dispatch(getcyclelist(id)),
  onupdatePayment: (payload) => dispatch(updatePayment(payload)),
  onGetBankList: (id) => dispatch(getbanklist(id)), // ✅ dispatch this
  confirmpayment: (id) => dispatch(confirmpayment(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ParticipantPayments);
